import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';
import { listByCategory } from '@/utils/content';

export default function CategoriesRow() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14" id="categories">
      <div className="mb-6 flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="flex items-center gap-2 font-display text-2xl text-ink md:text-3xl">
            <span className="inline-block h-7 w-1.5 rounded-full bg-primary-500" />
            五大爆点栏目
          </h2>
          <p className="mt-1 text-sm text-ink-600">挑一个你最好奇的方向，往下逛</p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {categories.map((c) => {
          const count = listByCategory(c.id).length;
          return (
            <Link
              key={c.id}
              to={`/column/${c.id}`}
              className="group flex flex-col rounded-xl border border-cream-200 bg-white p-5 transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <span className={`flex h-12 w-12 items-center justify-center rounded-xl text-2xl ${c.soft} ${c.chip}`}>
                <i className={c.icon} />
              </span>
              <h3 className="mt-4 text-base font-bold text-ink">{c.name}</h3>
              <p className="mt-1 line-clamp-2 flex-1 text-xs leading-relaxed text-ink-600">{c.slogan}</p>
              <span className="mt-3 flex items-center justify-between border-t border-cream-100 pt-3 text-xs text-ink-600">
                <span>{count} 篇盘点</span>
                <span className="flex items-center gap-1 font-bold text-primary-600 transition-transform group-hover:translate-x-0.5">
                  逛逛 <i className="ri-arrow-right-line" />
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}